import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["userId", "limit", "offset", "enabled"],
  _excluded2 = ["data"];
import _regeneratorRuntime from "@babel/runtime/regenerator";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { useQuery } from '@tanstack/react-query';
import api from 'utils/api';
import { DEFAULT_ITEMS_PER_PAGE } from 'utils/pagination';
import usersKeys from './queryKeys';
import useFetchUserHelixAccess from './useFetchUserHelixAccess';
function useFetchUserAnalysisWeeks(_ref) {
  var userId = _ref.userId,
    limit = _ref.limit,
    offset = _ref.offset,
    enabled = _ref.enabled,
    queryOptions = _objectWithoutProperties(_ref, _excluded);
  function queryFn() {
    return _queryFn.apply(this, arguments);
  } // checkIsHelixUser 403s the analysis endpoints unless this hub is the one
  // designated as the user's Helix hub, so fetching from anywhere else only
  // caches an error that outlives the hub being linked
  function _queryFn() {
    _queryFn = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      return _regeneratorRuntime.wrap(function (_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            return _context.abrupt("return", api('get', '/api/userAnalysis/weeks', {
              limit: limit || DEFAULT_ITEMS_PER_PAGE,
              offset: offset || 0,
              userId: userId
            }));
          case 1:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return _queryFn.apply(this, arguments);
  }
  var _useFetchUserHelixAcc = useFetchUserHelixAccess({
      userId: userId
    }),
    helixAccessData = _useFetchUserHelixAcc.data;
  var _ref2 = helixAccessData || {},
    isHelixHub = _ref2.isHelixHub;

  // if enabled is not explicitly set to false then only fetch once we know
  // this hub is the user's Helix hub
  if (enabled === true || enabled === undefined) {
    enabled = Boolean(isHelixHub);
  }
  var _useQuery = useQuery(_objectSpread(_objectSpread({}, queryOptions), {}, {
      queryFn: queryFn,
      queryKey: usersKeys.singleUserAnalysisWeeks(userId),
      staleTime: 5 * 60 * 1000,
      enabled: enabled
    })),
    data = _useQuery.data,
    result = _objectWithoutProperties(_useQuery, _excluded2);
  var items = (data === null || data === void 0 ? void 0 : data.items) || [];
  return _objectSpread({
    items: items
  }, result);
}
export default useFetchUserAnalysisWeeks;